import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { MimicFolder, MimicFolderViewData, RootDirectionOption, RootItem } from 'icreate/common/models/mimic-folder';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class MimicFolderService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async getByVesselId(vesselId: string): Promise<RootItem[]> {
        return await lastValueFrom(
            this.http.get<RootItem[]>(`${this.domain}/api/mimicFolder`, {
                headers: this.headers,
                params: { vesselId },
            })
        );
    }

    async getById(mimicFolderId: string): Promise<MimicFolderViewData> {
        return await lastValueFrom(
            this.http.get<MimicFolderViewData>(`${this.domain}/api/mimicFolder/${mimicFolderId}`, {
                headers: this.headers,
            })
        );
    }

    async create(mimicFolderData: MimicFolder) {
        return await lastValueFrom(
            this.http.post<MimicFolderViewData>(`${this.domain}/api/mimicFolder`, mimicFolderData, {
                headers: this.headers,
            })
        );
    }

    async duplicateMimicFolder(mimicFolderData: MimicFolder) {
        return await lastValueFrom(
            this.http.post(`${this.domain}/api/mimicFolder/copy`, mimicFolderData, {
                headers: this.headers,
            })
        );
    }

    async update(mimicFolderData: MimicFolder) {
        return await lastValueFrom(
            this.http.put(`${this.domain}/api/mimicFolder/${mimicFolderData.id}`, mimicFolderData, {
                headers: this.headers,
            })
        );
    }

    async deleteById(mimicFolderId: string, vesselId: string) {
        return await lastValueFrom(
            this.http.delete(`${this.domain}/api/mimicFolder/${mimicFolderId}?vesselId=${vesselId}`)
        );
    }

    async deleteWithoutMimics(mimicFolderId: string, vesselId: string) {
        return await lastValueFrom(
            this.http.delete(`${this.domain}/api/mimicFolder/${mimicFolderId}?vesselId=${vesselId}&preserveMimics=true`)
        );
    }

    async updateIndex(currentIndex: number, targetIndex: number, vesselId: string) {
        return await lastValueFrom(
            this.http.post(`${this.domain}/api/mimicFolder/move`, {
                currentIndex,
                targetIndex,
                vesselId,
            })
        );
    }

    async sortRoot(vesselId: string, direction: RootDirectionOption) {
        return await lastValueFrom(
            this.http.post(
                `${this.domain}/api/mimicFolder/sort`,
                {
                    vesselId,
                    direction,
                },
                {
                    headers: this.headers,
                }
            )
        );
    }
}
